import { graphql } from 'react-relay';

import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

import type {
	useSpaceValidationQueryQuery$data,
	useSpaceValidationQueryQuery$variables,
} from './__generated__/useSpaceValidationQueryQuery.graphql.ts';

export const useSpaceValidationQuery = (spaceKey: string, skip?: boolean) => {
	const { data, error, loading } = useQueryInterop<
		useSpaceValidationQueryQuery$data,
		useSpaceValidationQueryQuery$variables
	>(
		graphql`
			query useSpaceValidationQueryQuery($spaceKey: String!) {
				space(key: $spaceKey) {
					id
				}
			}
		`,
		{
			variables: { spaceKey },
			skip: skip || !spaceKey,
		},
	);

	return { data, error, loading };
};
